/* PeekoraLab Shopify 2.0 sync layer: keeps discounts, variant availability, and product forms tied to Shopify data. */
(function () {
  'use strict';

  function moneyText(cents, fallback) {
    if (typeof cents !== 'number' || isNaN(cents)) return fallback || '';
    try {
      return (Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function parseBool(value) {
    return String(value) === 'true';
  }

  function applyDiscount() {
    var input = document.getElementById('discount-code');
    var msg = document.getElementById('discount-msg');
    if (!input) return;
    var code = input.value.trim();
    if (!code) {
      if (msg) msg.textContent = 'Enter a discount code first.';
      return;
    }
    if (msg) msg.textContent = 'Applying discount in Shopify checkout…';
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }

  window.applyDiscount = applyDiscount;

  function updateVariantUI(select, isInitial) {
    if (!select || !select.options || !select.options.length) return;
    var section = select.closest('[data-peekora-product-section]') || document;
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var available = parseBool(option.getAttribute('data-available'));
    var price = option.getAttribute('data-price') || '';
    var compare = option.getAttribute('data-compare') || '';
    var policy = option.getAttribute('data-policy') || '';
    var qty = parseInt(option.getAttribute('data-inventory-quantity') || '0', 10);
    var sku = option.getAttribute('data-sku') || '';

    section.querySelectorAll('[data-peekora-price]').forEach(function (el) { if (price) el.textContent = price; });
    section.querySelectorAll('[data-peekora-sticky-price]').forEach(function (el) { if (price) el.textContent = price; });

    section.querySelectorAll('[data-peekora-compare]').forEach(function (el) {
      if (compare) {
        el.textContent = compare;
        el.classList.remove('is-hidden');
        el.hidden = false;
      } else {
        el.textContent = '';
        el.classList.add('is-hidden');
        el.hidden = true;
      }
    });

    section.querySelectorAll('[data-peekora-atc]').forEach(function (btn) {
      btn.disabled = !available;
      btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      btn.textContent = available ? (btn.getAttribute('data-add-label') || 'Add to Cart') : (btn.getAttribute('data-sold-label') || 'Sold Out');
    });

    section.querySelectorAll('[data-peekora-payment-button]').forEach(function (el) {
      el.hidden = !available;
    });

    section.querySelectorAll('[data-peekora-stock-status]').forEach(function (el) {
      if (!available) el.textContent = 'Sold out';
      else if (policy === 'continue' && qty <= 0) el.textContent = 'Available to order';
      else if (qty > 0 && qty <= 5) el.textContent = 'Low stock — ' + qty + ' left';
      else el.textContent = 'In stock';
    });

    section.querySelectorAll('[data-peekora-sku]').forEach(function (el) {
      el.textContent = sku ? 'SKU: ' + sku : '';
      el.hidden = !sku;
    });

    if (isInitial) return;

    var mediaId = option.getAttribute('data-media-id');
    if (mediaId) {
      var target = section.querySelector('[data-peekora-slide][data-media-id="' + mediaId + '"]');
      if (target) target.click && target.click();
    }

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }

  function bundleStatus(bundle, message, isError) {
    var status = bundle && bundle.querySelector('[data-peekora-bundle-status]');
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
    status.classList.toggle('pk-bms__status--error', Boolean(isError));
  }

  function selectedBundleItems(bundle, section) {
    var tier = bundle.querySelector('input[name^="peekora-bundle-tier-"]:checked');
    if (!tier) throw new Error('Please choose a bundle first.');

    var quantity = Math.max(1, parseInt(tier.getAttribute('data-qty') || '1', 10));
    var selectedTier = tier.closest('.pk-bms__tier');
    var selectedVariants = selectedTier ? Array.prototype.slice.call(selectedTier.querySelectorAll('[data-pk-unit-variant]:checked')) : [];
    var fallback = section.querySelector('[data-peekora-variant-select]');
    var fallbackId = fallback ? parseInt(fallback.value, 10) : 0;
    var ids = [];

    for (var i = 0; i < quantity; i += 1) {
      var variantId = selectedVariants[i] ? parseInt(selectedVariants[i].value, 10) : fallbackId;
      if (!variantId) throw new Error('Please select a colour for every microscope.');
      ids.push(variantId);
    }

    var grouped = {};
    ids.forEach(function (id) { grouped[id] = (grouped[id] || 0) + 1; });
    return Object.keys(grouped).map(function (id) {
      return { id: parseInt(id, 10), quantity: grouped[id], properties: { _peekora_bundle: String(quantity) } };
    });
  }

  function loadGiftVariant() {
    var handle = 'microscope-60-120x-lab-handheld-microscope-battery-powered-microscope-with-led-light-kids-science-microscope';
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('The free gift is currently unavailable.');
        return response.json();
      })
      .then(function (product) {
        var variant = (product.variants || []).find(function (item) { return item.available; }) || (product.variants || [])[0];
        if (!variant || !variant.id) throw new Error('The free gift is currently unavailable.');
        return parseInt(variant.id, 10);
      });
  }

  function initBundleAdd(section) {
    var bundle = section.querySelector('[data-peekora-bundle]');
    var button = bundle && bundle.querySelector('[data-peekora-bundle-add]');
    if (!bundle || !button || button.dataset.peekoraBundleReady === 'true') return;
    button.dataset.peekoraBundleReady = 'true';

    button.addEventListener('click', function () {
      if (button.disabled || button.getAttribute('aria-busy') === 'true') return;
      var original = button.innerHTML;
      var items;

      try {
        items = selectedBundleItems(bundle, section);
      } catch (error) {
        bundleStatus(bundle, error.message, true);
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = '<span>Adding your bundle…</span>';
      bundleStatus(bundle, 'Adding your bundle and free gift…', false);

      loadGiftVariant()
        .then(function (giftVariantId) {
          items.push({
            id: giftVariantId,
            quantity: 1,
            properties: { _free_gift: 'Peekora MiniScope', _peekora_bundle_gift: 'true' }
          });
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this bundle.');
            return data;
          });
        })
        .then(function () {
          bundleStatus(bundle, 'Bundle added — your free gift is in the cart.', false);
          document.dispatchEvent(new CustomEvent('peekora:cart:updated', { detail: { open: true } }));
          if (window.PeekoraMiniCart && typeof window.PeekoraMiniCart.open === 'function') {
            window.PeekoraMiniCart.open();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          bundleStatus(bundle, error.message || 'Unable to add this bundle. Please try again.', true);
        })
        .finally(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = original;
        });
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-peekora-variant-select]')) {
      updateVariantUI(event.target);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-peekora-variant-select]').forEach(function (select) {
      updateVariantUI(select, true);
    });

    document.querySelectorAll('[data-peekora-product-section]').forEach(initBundleAdd);

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-peekora-atc], button[type="submit"][name="add"]');
        if (btn && !btn.disabled) btn.setAttribute('aria-busy', 'true');
      });
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector ? event.target.querySelector('[data-peekora-product-section]') : null;
    if (section) initBundleAdd(section);
  });
})();
